export enum Platform {
  LINE = "LINE",
  FACEBOOK = "FACEBOOK",
  OFFLINE = "OFFLINE",
  INSTAGRAM = "INSTAGRAM",
}
